import { Tooltip } from "@mui/material";
import { SmallBody, TinyBody } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";
import { ChannelType } from "store/types";

import { channelTypesI18n } from "..";
import type { IChannel } from "../types";
import { getLegacyMilestoneBaseTypeLabel } from "../utils";
import styles from "./style.module.scss";

type ChannelLegacyCalculationBaseFooterProps = {
    channel: Pick<IChannel, "type" | "hasMilestones" | "usesAlternativeMilestoneAmount">;
};

/**
 * Legacy footer for former channel-level calculation / milestone bases (book portal, channel details).
 */
export const ChannelLegacyCalculationBaseFooter = ({ channel }: ChannelLegacyCalculationBaseFooterProps) => {
    const [t] = useTranslation();

    // Post-revamp channels store type=null: no former channel-level base to show.
    if (channel.type == null) return null;

    const calcLabel = channelTypesI18n()[channel.type as ChannelType];
    const milestoneBaseLabel = getLegacyMilestoneBaseTypeLabel(channel);

    return (
        <div className={styles["channel-legacy-calculation-base-footer"]}>
            <Tooltip title={t("Channels.LegacyChannelCalculationBaseTooltip")} arrow>
                <SmallBody color="grey" className={styles["channel-legacy-calculation-base-footer__label"]}>
                    {t("Channels.LegacyChannelCalculationBase", { type: calcLabel })}
                </SmallBody>
            </Tooltip>
            {milestoneBaseLabel && (
                <Tooltip title={t("Channels.LegacyChannelMilestoneBaseTooltip")} arrow>
                    <SmallBody color="grey" className={styles["channel-legacy-calculation-base-footer__label"]}>
                        {t("Channels.LegacyChannelMilestoneBase", { type: milestoneBaseLabel })}
                    </SmallBody>
                </Tooltip>
            )}
            <TinyBody color="grey">{t("Channels.LegacyChannelCalculationBaseHint")}</TinyBody>
        </div>
    );
};
